import { redirect } from "react-router-dom";
import { Breadcrumb } from "../../components/Breadcrumb";
import { requireAuth } from "../auth/RequireAuth";
import { userStore } from "../../store/user";
import { UidManagerPage } from "./UidManagerPage";

// Admin-only: bulk delete removes cashless assets (and their balances) for good.
const uidManagerAuthGate = async () => {
  const user = userStore.getState().user;
  if (!user) return redirect("/login");
  if (user.role_id !== 1) return redirect("/");
  return null;
};

export const uidManagerRouter = {
  path: "/uid-manager",
  id: "uid-manager",
  element: <UidManagerPage />,
  loader: requireAuth(undefined, uidManagerAuthGate),
  handle: {
    crumb: () => <Breadcrumb name="UID Manager" href="/uid-manager" />,
  },
};
